import Vue from 'vue'
import Vuex from 'vuex'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    permission,
  },
  state: {
    userInfo: null,
    token: null,
    menuData: null
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_MENU_DATA(state, menuData) {
      state.menuData = menuData
    },
    CLEAR_USER_DATA(state) {
      state.userInfo = null
      state.token = null
      state.menuData = null
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setMenuData({ commit }, menuData) {
      commit('SET_MENU_DATA', menuData)
    },
    clearUserData({ commit }) {
      commit('CLEAR_USER_DATA')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo,
    token: state => state.token,
    menuData: state => state.menuData
  }
})
